module.exports = __webpack_public_path__ + "media/img/black_wood-a6f9225e1cd93f29cdaa20397da8a287.jpg";